var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.51998 24.0097L20.786 0.19043L24.0687 2.98597L23.7025 3.4158C22.7696 4.51427 22.3684 5.88973 22.4767 7.227C22.5849 8.56109 23.1994 9.85378 24.2979 10.7899C25.3964 11.7228 26.7718 12.124 28.1091 12.0157C29.4432 11.9075 30.7359 11.2929 31.672 10.1945L32.0381 9.76464L35.3208 12.5602C28.4466 20.6443 21.5692 28.7284 14.6887 36.8093L11.4028 34.0138L11.769 33.5839C12.7019 32.4855 13.103 31.11 12.9948 29.7727C12.8865 28.4386 12.272 27.1459 11.1736 26.2098C10.0751 25.2769 8.6996 24.8758 7.36233 24.984C6.02825 25.0923 4.73556 25.7068 3.79947 26.8053L3.43332 27.2351L0.147461 24.4396L0.513626 24.0097H0.51998ZM20.9165 1.77923L1.74582 24.3122L3.33143 25.6622C4.42672 24.5828 5.83404 23.9715 7.27957 23.8569C8.90021 23.7264 10.5718 24.2167 11.9091 25.3534C13.2463 26.4932 13.9977 28.0661 14.1283 29.6868C14.2461 31.1323 13.8672 32.616 12.9789 33.8705L14.5645 35.2205L33.7352 12.6875L32.1496 11.3375C31.0543 12.4169 29.647 13.0282 28.2014 13.1428C26.5808 13.2734 24.9092 12.783 23.572 11.6464C22.2347 10.5065 21.4833 8.93362 21.3527 7.31298C21.2349 5.86745 21.6138 4.38372 22.5021 3.12923L20.9165 1.77923Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69824 23.2363L5.84105 20.7178L6.70073 21.4469L4.5579 23.9686L3.69824 23.2363Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 19.8703L8.70531 17.3486L9.56498 18.0778L7.41899 20.5995L6.5625 19.8703Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42871 16.5012L11.5715 13.9795L12.4312 14.7118L10.2852 17.2303L9.42871 16.5012Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.291 13.1328L14.437 10.6143L15.2967 11.3434L13.1507 13.8651L12.291 13.1328Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1572 9.76781L17.3032 7.24609L18.1597 7.97842L16.0169 10.4969L15.1572 9.76781Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0225 6.39937L20.1653 3.88086L21.0249 4.60998L18.8821 7.13168L18.0225 6.39937Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4531 32.3869L16.5959 29.8652L17.4556 30.5975L15.3128 33.1192L14.4531 32.3869Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3184 29.0185L19.4612 26.5L20.3208 27.2291L18.1748 29.7508L17.3184 29.0185Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1816 25.6526L22.3276 23.1309L23.1873 23.8632L21.0413 26.3817L20.1816 25.6526Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0469 22.2842L25.1929 19.7656L26.0525 20.4948L23.9066 23.0165L23.0469 22.2842Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9121 18.9192L28.0581 16.3975L28.9146 17.1266L26.7718 19.6483L25.9121 18.9192Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7773 15.55L30.9202 13.0283L31.7798 13.7606L29.637 16.2823L28.7773 15.55Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.955dc69cb4549c83cedb7ae428702f80.svg";
export { ForwardRef as ReactComponent };